import { stringify } from 'query-string'
import { API_Manager_BASE_URL, API_TIMEOUT } from 'shared/constants/defaultENV'

import { Api } from './ApiGlobals'

const ManagerApi = new Api()

ManagerApi.instance.defaults = {
  ...ManagerApi.instance.defaults,
  baseURL: API_Manager_BASE_URL,
  timeout: API_TIMEOUT,
}

ManagerApi.instance.defaults.paramsSerializer = function (params) {
  return stringify(params)
}

export default ManagerApi
